import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import Carousel from './Carousel'
import Icon from './Icon'
import Testimonial from './Testimonial'

class TestimonialsCarousel extends Component {
  constructor () {
    super()
    this.state = { hasMounted: false }
  }
  componentDidMount () {
    // NOTE: normally a bad idea to setState in componentDidMount,
    // as it causes extra render - but that is _exactly_ what we need here.
    // We have to force this re-render here client side _after_ the initial
    // reactDOM.hydrate, because this method does not make up for differences between
    // what we return on the server and what we need on the client
    // (which is viewport size dependant)
    this.setState({ hasMounted: true })
  }
  render () {
    const { slides, extraClass, greaterThanXl, greaterThanXxl } = this.props
    const { hasMounted } = this.state
    if (!hasMounted) {
      // we don’t know how many items we can show on the server..
      return (
        <div className={extraClass}>
          {slides && <Testimonial {...slides[0]} />}
        </div>
      )
    }
    // _very_ brittle
    let centerPadding = '40px'
    if (greaterThanXxl) {
      centerPadding = '280px'
    } else if (greaterThanXl) {
      centerPadding = '260px'
    }
    return (
      <Carousel
        extraClass={classnames(
          'testimonials-carousel grey',
          extraClass,
          slides.length === 1 && 'testimonials-carousel--single-item'
        )}
        slides={slides}
        sliderOptions={{
          autoplay: false,
          autoplaySpeed: 6000,
          slidesToShow: 1,
          centerPadding,
          centerMode: slides.length > 1,
          dots: false,
          arrows: slides.length > 1,
          // need extra divs because react-slick overrides the classname on the element passed in
          prevArrow: (
            <div>
              <Icon
                className='icon testimonials-carousel__arrow'
                icon='carousel-arrow-left'
              />
            </div>
          ),
          nextArrow: (
            <div>
              <Icon
                className='icon testimonials-carousel__arrow'
                icon='carousel-arrow-right'
              />
            </div>
          )
        }}
        slideRenderFn={testimonial => <Testimonial {...testimonial} />}
      />
    )
  }
}

TestimonialsCarousel.propTypes = {
  extraClass: PropTypes.string,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      content: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
    }).isRequired
  ).isRequired,
  greaterThanXl: PropTypes.bool.isRequired,
  greaterThanXxl: PropTypes.bool.isRequired
}

function mapStateToProps ({ browser }) {
  return {
    greaterThanXl: browser.greaterThan.xl,
    greaterThanXxl: browser.greaterThan.xxl
  }
}

export default connect(mapStateToProps)(TestimonialsCarousel)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/TestimonialsCarousel.js